<template>
  <div>
      master
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>